import { Components } from "@mui/material";

export const MuiInputAdornment: Components["MuiInputAdornment"] = {
  styleOverrides: {
    positionEnd: {
      marginRight: "-5px",
    },
  },
};
